module.exports = __webpack_public_path__ + "img/ordCaffeine2.e1f56a51.jpg";